/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from 'react';
import TopNav from '../components/topnav';
import Footer from '../components/footer';
import useSiteMetadata from '../hooks/use-site-metadata';
import '../styles/global.scss';
var Layout = function Layout(_ref) {
    var children = _ref.children;
    var _useSiteMetadata = useSiteMetadata(), title = _useSiteMetadata.title;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TopNav, {
        brandName: title
    }), /*#__PURE__*/ React.createElement("main", {
        className: "pt-navbar"
    }, children), /*#__PURE__*/ React.createElement(Footer, {
        brandName: title
    }));
};
export default Layout;
